import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { IoClose } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import MaualList from './MaualList';
import MaualList2 from './MaualList2';
import MaualContent from './MaualContent';
import MaualAdmin from './MaualAdmin';
import MaualCategoryAdmin from './MaualCategoryAdmin';
import './MaualLayout.scss';

const MaualLayout = () => {
    const isAdmin = useSelector((state) => state.appReducer.isAdmin);
    const isLoggedIn = useSelector((state) => state.appReducer.isLoggedIn);
    const canShowAdminControls = isLoggedIn && isAdmin;
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedContent, setSelectedContent] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAdminMode, setIsAdminMode] = useState(false);
    const [isCategoryAdminMode, setIsCategoryAdminMode] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [categoryRefreshKey, setCategoryRefreshKey] = useState(0);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleSelectContent = (content) => {
        setSelectedContent(content);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleToggleAdmin = () => {
        setIsAdminMode(!isAdminMode);
        if (!isAdminMode) {
            setIsModalOpen(false);
            setIsCategoryAdminMode(false);
        }
    };

    const handleToggleCategoryAdmin = () => {
        setIsCategoryAdminMode(!isCategoryAdminMode);
        if (!isCategoryAdminMode) {
            setIsModalOpen(false);
            setIsAdminMode(false);
        }
    };

    const handleAdminSave = () => {
        // 관리자 저장 후 목록 새로고침
        setRefreshKey(prev => prev + 1);
    };

    const handleCategoryAdminSave = () => {
        // 카테고리 저장 후 사이드바 새로고침
        setCategoryRefreshKey(prev => prev + 1);
    };

    return (
        <div className="MaualLayout">
            <Helmet>
                <title>사용 설명서 - 매쓰테일러</title>
                <meta name="description" content="매쓰테일러 기능별 사용 설명서입니다. PDF HWP 변환, 수학 문제풀이 AI, 도형 작도 AI의 사용법을 안내합니다." />
                <meta name="keywords" content="매쓰테일러 사용법, PDF HWP 변환 방법, 수학 AI 사용 설명서" />
                <meta property="og:title" content="사용 설명서 - 매쓰테일러" />
                <meta property="og:url" content="https://xn--vl2b19ao0ssqc39r.kr/manual" />
            </Helmet>
            {/* 모바일 카테고리 토글 버튼 */}
            <div className="mobile-topbar">
                <button
                    className="btn-mobile-sidebar-toggle"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                >
                    {isSidebarOpen ? '✕' : '☰'}
                </button>
                {selectedCategory && !isSidebarOpen && (
                    <span className="mobile-category-title">{selectedCategory.unit1_name}</span>
                )}
            </div>

            {/* 모바일 오버레이 */}
            {isSidebarOpen && (
                <div className="mobile-sidebar-overlay" onClick={() => setIsSidebarOpen(false)} />
            )}

            <aside className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
                {/* 카테고리 관리자 버튼 (사이드바 내부 우측) */}
                {canShowAdminControls && (
                    <button 
                        className="btn-category-admin" 
                        onClick={handleToggleCategoryAdmin}
                        title="카테고리 관리"
                    >
                        관리자
                    </button>
                )}
                <MaualList 
                    onSelectCategory={(cat) => {
                        setSelectedCategory(cat);
                        setIsSidebarOpen(false);
                    }}
                    refreshKey={categoryRefreshKey}
                />
            </aside>
            <main className="content">
                {isCategoryAdminMode ? (
                    <MaualCategoryAdmin 
                        onClose={handleToggleCategoryAdmin}
                        onSave={handleCategoryAdminSave}
                    />
                ) : !isAdminMode ? (
                    <>
                        <div className="content-header-bar">
                            {canShowAdminControls && (
                                <button className="btn-admin-toggle" onClick={handleToggleAdmin}>
                                    관리자 content
                                </button>
                            )}
                        </div>
                        <MaualList2 
                            selectedCategory={selectedCategory}
                            onSelectContent={handleSelectContent}
                            refreshKey={refreshKey}
                        />
                    </>
                ) : (
                    <MaualAdmin 
                        selectedCategory={selectedCategory}
                        onClose={handleToggleAdmin}
                        onSave={handleAdminSave}
                    />
                )}
            </main>

            {isModalOpen && !isAdminMode && !isCategoryAdminMode && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={handleCloseModal}>
                            <IoClose />
                        </button>
                        <MaualContent selectedContent={selectedContent} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default MaualLayout;
